// extracted by mini-css-extract-plugin
module.exports = {"banner":"ShutdownBanner_banner__hOKnD","content":"ShutdownBanner_content__NJQ9U","title":"ShutdownBanner_title__b9_D0"};